<template>
    <el-dialog :visible.sync="contactEditDialogVisible" @close="$emit('input', false)">
        <el-form :model="contactData" ref="contactEditForm" :rules="rules">
            <el-row style="margin-bottom: 5px;" :gutter="20">
                <el-col :span="6" :offset="6">
                    <el-form-item prop="name" label="姓名">
                        <el-input v-model="contactData.name" placeholder="请输入联系人姓名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="cellphone" label="手机">
                        <el-input v-model="contactData.cellphone" placeholder="请输入联系人手机号码"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;" :gutter="20">
                <el-col :span="6" :offset="6">
                    <el-form-item prop="dept" label="部门">
                        <el-input v-model="contactData.dept" placeholder="请输入联系人部门"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="email" label="邮箱">
                        <el-input v-model="contactData.email" placeholder="请输入联系人邮箱"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;" :gutter="20">
                <el-col :span="6" :offset="6">
                    <el-form-item prop="position" label="岗位">
                        <el-input v-model="contactData.position" placeholder="请输入联系人岗位"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="telephone" label="固话">
                        <el-input v-model="contactData.telephone" placeholder="请输入联系人固话"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;" :gutter="20">
                <el-col :span="6" :offset="6">
                    <el-form-item prop="level" label="职级">
                        <el-input v-model="contactData.level" placeholder="请输入联系人职级"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="other_contact_information" label="其他联系方式">
                        <el-input v-model="contactData.other_contact_information" placeholder="其他联系方式"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;" :gutter="20">
                <el-col :span="6" :offset="6">
                    <el-form-item prop="gender" label="性别">
                        <el-select v-model="contactData.gender" placeholder="请选择联系人性别">
                            <el-option label="男" value="男"></el-option>
                            <el-option label="女" value="女"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="status" label="是否在职">
                        <el-select v-model="contactData.status" placeholder="是否在职">
                            <el-option label="是" :value="1"></el-option>
                            <el-option label="否" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" :offset="6">
                    <el-form-item prop="responsible_items" label="负责事项">
                        <el-input v-model="contactData.responsible_items" type="textarea" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" :offset="6">
                    <el-form-item prop="other_describe" label="其他描述">
                        <el-input v-model="contactData.other_describe" type="textarea" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button :loading="loading" type="primary" @click="onSubmit('contactEditForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {editContactBaseinfo} from '@/api/api'
export default {
    name: "ContactEdit",
    props: {
        value:{
            type: Boolean,
            default:false,
            required: true
        },
        contactInfoDetailForm: {
            type: Object
        }
    },
    data() {
        return {
            contactEditDialogVisible: false,
            loading: false,
            contactData: {
                client_id: this.clientId,
                dept: "",
                position: "",
                level: "",
                status: "",
                responsible_items: "",
                other_describe: "",
                name: "",
                gender: "",
                cellphone: "",
                email: "",
                telephone: "",
                other_contact_information: ""
            },
            rules: {
                name: [
                    {required: true, message: "请输入联系人名称", trigger: "blur"}
                ]
            }
        }
    },

    watch: {
        contactInfoDetailForm(newVal) {
            this.contactData = JSON.parse(JSON.stringify(newVal))
        },

        value(newVal) {
            this.contactEditDialogVisible = newVal
        }
    },

    methods: {
        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    this.editContactAction()
                }else{
                    return false
                }
            });
        },

        async editContactAction() {
            this.loading = true
            let editList = []
            for (let formKey in this.contactData){
                if(this.contactData[formKey] !== this.contactInfoDetailForm[formKey]){
                    editList.push({
                        key: formKey,
                        new_value: this.contactData[formKey]
                    })
                }
            }
            let postData = {
                client_id: this.contactInfoDetailForm['client_id'],
                contact_id: this.contactInfoDetailForm['contact_id'],
                edit_info: editList
            }
            let res = await editContactBaseinfo(postData)
            if(res.respCode&&res.respCode=='000000') {
                this.$message.success(res.respMsg)
                this.$emit('refresh', this.contactData.name)
                this.$nextTick(()=>{
                    this.loading = false
                    this.$emit('input',false)
                })
            }else{
                this.$message.error(res.respMsg)
            }
        }
    }
}
</script>
<style scoped>
.el-dialog {
    width: 30%;
}
</style>
